// @flow
export default {
  tpos: {
    basketArea: {
      placeOrder: "Place Order",
      items: "Items",
      resetOrder: "Reset Order",
    },
    productArea: {
      specialOrder: "Special Order",
      customiseIndividual: "Customise Individually",
      updateAllItems: "Update all items",
      removeItem: "Remove Item",
      noItemsInCategory: "No items available in this category",
    },
    orderArea: {
      confirmOrderHeader: "Confirm this Order?",
      confirmOrderText:
        "Please make sure the customer is finished ordering before confirming the order.",
      editOrder: "Edit Order",
      confirmOrder: "Confirm order",
      placedOrder: {
        lane: "Lane: {{lane}}",
        noLane: "Order Placed",
        placedOrderText:
          "Please point customer to the correct lane before taking a new order",
        noLanePlacedOrderText:
          "Direct the customer to check-in at the Entrance Kiosk before taking a new order",
        newOrder: "Take a new order",
      },
      processingOrder: "Processing Order...",
      processingOrderText: "Please wait while the order is being placed.",
      aggregatorOrder: {
        orderConfirmed: "Order Confirmed",
        nextOrder:
          "This order has been confirmed. Please take the next aggregator order.",
      },
    },
    settings: "Settings",
    pickupDriveThru: {
      button: "Pickup Drive thru",
      title: "Pickup Drive thru",
      back: "Back",
      heading: "ENTER ORDER DETAILS",
      posOrderIdentifier: "POS ORDER IDENTIFIER",
      orderIdentifierPlaceholder: "insert order identifier",
      orderPinPlaceholder: "insert pin",
      orderPin: "ORDER PIN",
      submit: "Submit",
      delete: "Delete",
      orderVerified: "ORDER VERIFIED",
      orderVerifiedMessage: "The order has been successfully verified.",
      mainMenu: "Main Menu",
      errors: {
        unauthorized: "You are not authorized to perform this action.",
        orderNotFound: "Order not found at this branch.",
        alreadyCheckedIn: "This order has already been checked in.",
        validationFailed:
          "Verification failed. Please check the details and try again.",
        networkError:
          "Unable to connect to the server. Please check your connection.",
        unknown: "An error occurred. Please try again.",
      },
    },
    profileArea: {
      confirmLogout: "Please confirm if you'd like to sign out.",
      yesLogout: "Yes, sign out",
      noLogout: "No, go back",
      mode: "Aggregator mode",
      off: "Off",
      on: "On",
    },
    orderHistoryArea: {
      reprintReceipt: "Reprint Receipt",
      pin: "PIN:",
    },
    aggregators: {
      Careem: "Careem Now",
      Wssel: "Wssel",
      ToYou: "To You",
      Jahez: "Jahez",
    },
    printerArea: {
      errorTitle: "Printer Error",
      errorDescription: "Printing unavailable or configured incorrectly.",
      errorOrder:
        "The order has been placed, but the receipt failed to print. Please reprint the receipt",
    },
  },
  checkoutScreen: {
    addressConfirmed: "Address confirmed",
    checkout: "CHECKOUT",
    summary: "SUMMARY",
    orderOptions: "ORDER OPTIONS",
    paymentOptions: "PAYMENT OPTIONS",
    confirmOrder: "Confirm Order",
    extraSauces: "Extra sauces",
    pickup: "PICK UP",
    pricesInclude: "Prices include {{taxPercent}}% VAT",
    productsValue: "Products Value",
    basket: "Basket",
    viewBasket: "View Basket",
    groupOrder: {
      basketStatus: {
        makingChanges: "Making changes",
        confirmed: "Confirmed",
        failedToJoin: "Failed to join",
        browsing: "Browsing...",
        joining: "Joining...",
      },
      groupBasket: "Group Basket",
      viewGroupBasket: "View Group Basket",
      yourItems: "Your items",
      notAddedItems: "You have not added items to your basket",
      group: "Group ({{usersCount}})",
      noUsersJoined: "No one has joined the order yet...",
      groupOrderIntro:
        "Collect orders from friends, family & co-workers. Share the order to get started.",
      share: "Share",
      refresh: "Refresh",
    },
    deleteButton: "Delete",
    checkoutError: "Checkout Error",
    removeAll: {
      button: "Remove All",
      cancel: "Cancel",
      modalTitle: "Remove all items",
      modalBody:
        "Are you sure that you would like to remove all items from your basket?",
    },
    unavailableItem:
      "One or more items in your basket are now unavailable. They have been removed.",
    okModalButton: "OK",
    unavailable: "Unavailable",
    edit: "Edit",
  },
  currency: "SR {{amount}}",
  editBasketItemScreen: {
    updateOrder: "Update order",
  },
  homeScreen: {
    all: "Main Menu",
    ourMenu: "OUR MENU",
    deliveryButton: "Delivery",
    modal: {
      addressConfirmed: "Address confirmed",
      orderOptions: "Order Options",
      chooseAddress: "Choose an address",
      chooseRestaurant: "Choose a restaurant",
      skipNow: "Skip for now",
      deliverTo: "Delivery to:",
      deliverToAddress: "Deliver to an address",
      pickupFromRestaurant: "Pickup (currently unavailable)",
      pickupAvailable: "Pickup",
    },
    menuAvailability: {
      timeRange: "{{startTime}} - {{endTime}}",
      modalText:
        "This item is only available during these periods: {{timeRange}}",
      unavailable: "Unavailable",
      unavailableText: "This item is currently unavailable",
      okModalButton: "OK",
      monday: "Mon",
      tuesday: "Tues",
      wednesday: "Weds",
      thursday: "Thurs",
      friday: "Fri",
      saturday: "Sat",
      sunday: "Sun",
    },
  },
  itemScreen: {
    addToOrder: "Add to order",
    amountv: "AMOUNT",
    free: "Free",
    kCalories: "kcal",
    nutritionalInfo: "Nutritional Information",
    variations: "VARIATIONS",
    spicy: "Spicy",
    remove: "Remove",
  },
  locationScreen: {
    openingTimes: "Opening times",
    confirm: "Confirm",
    deliveryTo: "Delivery Address:",
    restaurant: "Restaurant:",
    deliveryChecker: "Delivery checker:",
    orderHere: "Order Here",
    viewAll: "View All",
    selectRestaurant: "SELECT RESTAURANT",
    waitTimeMinute: "Wait time: {{waitingTime}} minute",
    waitTimeMinutes: "Wait time: {{waitingTime}} minutes",
    delivery: "Delivery",
    pickup: "Pickup",
    calculating: "Calculating",
    cannotDeliver:
      "Unfortunately we cannot deliver to that location at this time",
    pickupChecker: "Pickup checker:",
    cannotPickup: "Unfortunately pickup is not available in your location.",
    pickupLocations: "Pickup locations",
    addressNotSelected: "Address not selected",
    defaultLocation: "Please choose the location to deliver your order",
    branchClosed: "This restaurant is currently closed",
    restaurantClosedTitle: "This restaurant is closed",
    openNow: "Open now",
    allBranches: "All branches",
    restaurantClosed:
      "The restaurant you have selected is currently closed. Please select an open restaurant or try again later.",
    distanceKm: "{{distance}} km",
    locations: "restaurants",
    search: "City, Branch",
  },
  loginScreen: {
    emailAddress: "EMAIL ADDRESS",
    errors: {
      passwordEightChar: "Password must be at least 8 characters",
      requiredEmail: "Email address is required",
      requiredFirstName: "First name is required",
      requiredPassword: "Password is required",
      requiredTelephone: "Mobile number is required",
      validTelephone: "Please enter a valid mobile number starting with 5",
      invalidKSAPhoneNumber:
        "Please enter a valid 9-digit mobile number starting with 5",
      validEmail: "Please enter a valid email address",
    },
    forgotPassword: "Forgot your password?",
    needToRegister: "Need to register?",
    password: "PASSWORD",
    signInButton: "Sign In",
  },
  orderHistoryScreen: {
    orderHistory: "ORDER HISTORY",
    cancelled: "CANCELLED",
    deliveryFailed: "FAILED",
    noRecentOrders: "You have no recent orders",
    statusAndInformation: "Status & Information",
  },
  orderScreen: {
    checkClosed: "Check Closed",
    needToCancel: "Need to cancel your order?",
    orderNumber: "Order #",
    status: "STATUS",
    orderStatus: {
      processing: "Processing your order",
      preparing: "Preparing your food",
      driverCollecting: "Driver collecting order",
      outForDelivery: "Out for delivery",
      delivered: "Delivered",
      failed: "There has been a problem \ndelivering this order to you",
    },
    pickupStatus: {
      collecting: "Order collecting",
      completed: "Order collected",
      picked_up: "Order collected",
      rejected: "Order rejected",
      failed: "Order failed",
    },
    pending: "Pending",
    pickupTime: "Pick up {{time}}",
    pickupAt: "Pick up at {{time}}",
    directions: "Directions",
    share: "Share Order Details",
    productsValue: "Products Value",
    thankYou:
      "Thank you for ordering with ALBAIK\nPrices include {{taxPercent}}% VAT",
    total: "Total",
    vat: "VAT ({{vat}}%)",
    yourOrder: "YOUR ORDER",
    yourItems: "Your Items",
    orderCancelled: "ORDER CANCELLED",
    findOrder: "You can still find this order in your 'Order History'",
    newOrder: "New order",
    somethingWrong: "Was something wrong?",
    contactSupport: "Contact support team",
    cancelled: "CANCELLED",
    cancelOrder: "Cancel order",
    cancelDialog: {
      title: "Cancelling your order",
      message: "Are you sure you want to cancel this order?",
      dismiss: "Dismiss",
    },
    expired: "Expired",
    timeLeft: "{{time}} mins left",
    timeLeftInSeconds: "{{time}} seconds left",
    viewQr: "View QR",
    vatAccountNumber: "VAT Account Number: {{vat}}",
    shareOrder: {
      albaikPickupOrder: "ALBAIK Pickup Order:",
    },
    shareDirections: {
      title: "Share directions?",
      message:
        "You have successfully shared your order. Would you also like to share directions to the restaurant?",
      yes: "Share",
      no: "Not right now",
    },
  },
  paymentScreen: {
    payWith: "Pay with",
    creditDebit: "Credit / Debit",
    checkout: "CHECKOUT",
    feeTax: "{{fee}} VAT ({{tax}}%)",
    continue: "Continue",
  },
  payWithCardScreen: {
    cardholderName: "CARDHOLDER NAME",
    cardNumber: "CARD NUMBER",
    expires: "EXPIRES (MM/YY)",
    cvv: "CVV",
    payWithCardButton: "Pay with card",
    loading: "Loading...",
    cancel: "Cancel",
    cardPreview: {
      cardholderName: "NAME",
      expires: "EXPIRES",
    },
    cvvConfirmation:
      "For security purposes, please confirm the security code on your card.",
    saveCard: "Save this card for later?",
    errors: {
      cardholderNameRequired: "Please enter the name of the cardholder",
      cardholderNameValid: "Please enter a valid name in English",
      cardNumberRequired: "Please enter your card number",
      cardNumberInvalid: "Your credit card number is not valid",
      expiresMonthRequired: "Please enter your card’s expiration month",
      expiresMonthLength: "Expiration month should be two digit month",
      expiresMonthInvalid: "Expiration month is invalid",
      expiresYearRequired: "Please enter your card’s expiration year",
      expiresYearLength: "Expiration year should be two digit year",
      expiresYearInvalid: "Expiration year is invalid",
      cvvRequired: "Please enter your card’s 3-4 digit CVV security code",
      cvvInvalid: "Your card’s CVV security code should be 3-4 numeric digits",
      savedCardsRetrieveError: "Error retrieving saved cards",
      payment: {
        default:
          "An error occurred submitting this order. Ensure your information is correct and try again",
        invalidTotal:
          "Cart total is invalid. Ensure that you have items in your basket",
        cardNumber: "The card number provided is invalid",
        securityCode: "The security code provided is invalid",
        expiryMonth: "The expiration month provided is invalid",
        expiryYear: "The expiration year provided is invalid",
        threeDSecureFailed:
          "An error occurred verifying this transaction with your bank. Please try again",
      },
    },
  },
  saveCardScreen: {
    saveCard: "Save Card",
  },
  profileScreen: {
    account: "Account",
    customerCare: "Customer Care",
    midHeader: "My ALBAIK",
    orderHistory: "Order History",
    payments: "Payments",
    register: "Register",
    sos: "SOS On The Go",
    signIn: "Sign In",
    signOut: "Sign Out",
    signOutDialog: {
      title: "Sign Out?",
      message: "Are you sure you want to sign out?",
      cancel: "Cancel",
    },
  },
  cardsScreen: {
    savedCards: "YOUR SAVED CARDS",
    addCard: "Add Card",
    anotherCard: "Another Card",
    ending: "ENDING",
    deleteCard: "Delete card (ending {{last4}})",
    errorTitle: "Error",
    deleteCardAlertTitle: "Delete payment card",
    deleteCardAlertText:
      "Are you sure you want to delete this card? (Ending {{last4}})",
    deleteModalOption: "Delete",
    cancelModalOption: "Cancel",
  },
  accountScreen: {
    english: "English",
    arabic: "العربية",
    contactDetails: "CONTACT DETAILS",
    accountSettings: "ACCOUNT SETTINGS",
    language: "LANGUAGE",
    submitError: "Details could not be saved.",
    submitSuccess: "Success! Your account details have been saved",
    save: "Save",
  },
  qrCodeDetailsScreen: {
    pickupOrder: "PICKUP ORDER",
    location: "LOCATION",
    orderPlaced: "ORDER PLACED",
    pickupTime: "Pickup Time",
    pickupPin: "Pickup PIN #",
    mobileNumber: "Mobile Number: ",
  },
  registerScreen: {
    alreadyHaveAccount: "Already Have an account?",
    firstName: "FIRST NAME",
    lastName: "LAST NAME",
    registerButton: "Register",
    telephone: "MOBILE",
  },
  smsSecureScreen: {
    smsConfirm: "SMS Confirmation",
    codeSent:
      "We have sent a 4-digit code SMS to the number provided {{mobile}}. Please enter it below.",
    verificationCode: "VERIFICATION CODE",
    resend: "Resend code",
    remaining: "{{attempts}}/5 remaining",
    smsError: "SMS Confirmation Error",
    codeResent: "Code Resent",
    thanks: "Thanks",
    maxAttempt: "You have reached the maximum attempt limit",
    resendCountDown: "Please wait {{seconds}} seconds before resending code.",
  },
  resetScreen: {
    loginToAccount: "Login to your account",
    resetButton: "Reset password",
    resetSuccess: "Please check your email for resetting the password",
  },
  locationAccessScreen: {
    grantAccess: "Grant location access",
    manualSearch: "Search manually",
    selectRestaurant: "SELECT RESTAURANT",
    accessRequest:
      "We do not have access to your location, please grant us access so we can recommend the closest and fastest restaurant for you! Otherwise you can search manually.",
  },
  connectionErrorScreen: {
    internetUnavailable: "Internet connection is not available",
    connectToInternet: "Please connect to the Internet to use the app",
    okButton: "OK",
  },
  userAuthorizationError: {
    message:
      "You have been logged out because your login session is either expired or invalid.",
  },
  versionUpgrade: {
    title: "New Version Available",
    message:
      "The new version is required to continue using the app. You will now be taken to the app store.",
    ok: "Ok",
    cancel: "Cancel",
  },
  launchPopup: {
    title: "Notice",
    message:
      "Dear Customer,\n\nWe are experiencing delays up to 2:00 hours to deliver your order during Eid Al Fitr.\n\nWe are doing our best to shorten your waiting time. We apologize for any inconvenience, and we thank you for your trust.",
  },
  rtlGuardScreen: {
    message:
      "Your language setting has been updated. The application will need to be restarted for the changes to take effect.",
    restart: "Restart",
  },
};
